import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="collect-event"
export default class extends Controller {
  static values = {
    name: String,
    payload: Object,
    trigger: { type: String, default: "connect" },
    once: { type: Boolean, default: true },
  };

  connect() {
    this.eventSent = false;

    if (this.triggerValue === "connect") {
      this.sendEvent();
      return;
    }

    this.element.addEventListener(this.triggerValue, this.sendEvent);
  }

  disconnect() {
    if (this.triggerValue === "connect") {
      return;
    }

    this.element.removeEventListener(this.triggerValue, this.sendEvent);
  }

  sendEvent = () => {
    if (document.body.dataset.impersonated === "true") {
      return;
    }

    if (this.onceValue && this.eventSent) {
      return;
    }

    this.eventSent = true;

    fetch("/collect", {
      method: "POST",
      body: JSON.stringify({
        name: this.nameValue,
        data: this.payloadValue || {},
      }),
      headers: {
        "Content-Type": "application/json",
      },
    });
  };
}
